import { FC } from "react";

import { Box } from "@chakra-ui/react";

import responsiveStyle from "@lib/theme/responsiveStyle";

const SectionTitle: FC<{ children?: any }> = ({ children }) => (
  <Box fontSize={responsiveStyle({ mobile: "1rem", desktop: "1.125rem" })}>{children}</Box>
);
export default SectionTitle;
